import React, { useState } from 'react';
import { Button } from '@gamesb42/ui-kit';
import { useHistory } from 'react-router-dom';
import { resendConfirmCode } from '../../../api/auth';
import appStore from '../../../store/App';

interface InvalidCodeScreenProps {
  code: string;
}

const InvalidCodeScreen: React.FC<InvalidCodeScreenProps> = ({ code }) => {
  const history = useHistory();
  const [resendSuccess, setResendSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      await resendConfirmCode({ code });
      setResendSuccess(true);
    } catch (error: any) {
      console.error('Resend invite error:', error);
      appStore.setNotification({
        type: 'error',
        title: 'Failed to Resend Invite',
        width: 380,
      });
    } finally {
      setLoading(false);
    }
  };

  if (resendSuccess) {
    return (
      <div style={{ textAlign: 'left' }}>
        <h2
          style={{
            marginBottom: '20px',
            color: '#090909',
            fontSize: '32px',
            fontWeight: 700,
            lineHeight: '40px',
            fontFamily: 'Muller',
          }}
        >
          Invitation Sent
        </h2>

        <p
          style={{
            display: 'block',
            marginBottom: '32px',
            color: '#606176',
            fontSize: '16px',
          }}
        >
          A new invitation has been sent to your email. Please check your inbox
          and follow the link.
        </p>

        <div>
          <span
            onClick={() => history.push('/login')}
            style={{
              color: '#5227cb',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            Back to Sign In
          </span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <h2
        style={{
          marginBottom: '20px',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Invite link expired
      </h2>

      <p
        style={{
          display: 'block',
          marginBottom: '32px',
          color: '#606176',
          fontSize: '16px',
        }}
      >
        For your security, invite links are only valid for a limited time
      </p>

      {code && (
        <Button
          type="primary"
          size="large"
          violet
          loading={loading}
          style={{
            color: '#fff',
            width: '178px',
            marginBottom: '24px',
          }}
          onClick={handleResend}
        >
          Resend Invite
        </Button>
      )}

      <div>
        <span
          onClick={() => history.push('/login')}
          style={{
            color: '#5227cb',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          Back to Sign In
        </span>
      </div>
    </div>
  );
};

export default InvalidCodeScreen;
